import { css } from '@/styled-system/css';

export const containerStyles = css.raw({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  flexDirection: { base: 'column', md: 'row' },
  margin: { base: '0', md: '{spacing.400} 0' },
  padding: { base: '{spacing.600} {spacing.300}', md: '{spacing.600} {spacing.1200}' },
});

export const detailsStyles = css.raw({
  textShadow: '0 2px 4px rgba(0, 0, 0, 0.5)',
  marginLeft: { base: '{spacing.500}', md: '0' },
  marginRight: { base: 'auto', md: '0' },
});
